import * as React from 'react';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { CompareBanner } from '../../components/CompareBanner';
import { CompareFlightModalContainer } from '../CompareFlightModalContainer';
import { trackCompareBanner } from './tracking';

export const CompareBannerContainer = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = React.useCallback(() => {
    setOpen(true);
    trackCompareBanner({ action: 'click_sopr' });
  }, []);

  const handleClickClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <ActionAfterViewObserver callback={() => trackCompareBanner({ action: 'show_sopr' })} triggerOnce>
        <CompareBanner onClick={handleClickOpen} />
      </ActionAfterViewObserver>

      {open && <CompareFlightModalContainer onClose={handleClickClose} />}
    </>
  );
};
